
// ===== File: src/components/Repository/KnowledgeTitleBar.jsx =====
import React from "react";
import "../../css/KnowledgeSpace.css";
import CloaseArrow from "../../assets/Images/CloseArrow.png";

const KnowledgeTitleBar = ({ breadcrumbPath = [], onCrumbClick, onNew }) => {
  return (
    <div className="knowledge-title-wrapper">
      <div className="knowledge-title-bar" aria-label="breadcrumb">
        {breadcrumbPath.map((label, i) => (
          <React.Fragment key={i}>
            <button
              className={`crumb profile-i ${
                i === breadcrumbPath.length - 1 ? "crumb-active" : ""
              }`}
              onClick={() =>
                typeof onCrumbClick === "function" && onCrumbClick(i)
              }
            >
              {label}
            </button>

            {i < breadcrumbPath.length - 1 && (
              <span className="knowledge-separator">
                <img src={CloaseArrow} alt="arrow" className="profile-i"/>
              </span>
            )}
          </React.Fragment>
        ))}
      </div>

      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        {onNew && (
          <button className="new-btn" onClick={onNew}>
            {/* + New */}
            <span className="profile-i">+ New</span>
          </button>
        )}
      </div>
    </div>
  );
};

export default KnowledgeTitleBar;
